import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import feedMappingsActions from '../../redux/feedMappings/actions';
import InventoryNav from '../../components/InventoryNav';
import FeedMappingList from '../../components/FeedMappingList';
import SidebarContainer from '../SidebarContainer';
import './FeedMappings.scss';

class FeedMappings extends Component {
  componentDidMount() {
    this.props.actions.resetFeedMapping();
    this.props.actions.feedMappingsRequest();
  }

  onEdit = async (feedMappingId) => {
    this.props.actions.feedMappingRequest(feedMappingId);
  };

  render() {
    const { actions, feedMappings } = this.props;
    return (
      <SidebarContainer
        title="Inventory Mapping Manager"
        openSubMenu="Inventory"
      >
        <div className="feed-mappings-table">
          <InventoryNav />
          <FeedMappingList
            list={feedMappings.feedMappings}
            error={feedMappings.error}
            success={feedMappings.success}
            fetching={feedMappings.fetching}
            onDelete={actions.deleteFeedMappingRequest}
            onEdit={this.onEdit}
          />
        </div>
      </SidebarContainer>
    );
  }
}

FeedMappings.propTypes = {
  feedMappings: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = ({ feedMappings }) => ({ feedMappings });

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...feedMappingsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedMappings);
